module.exports = {"text":"Zlá ruta","button":"Späť"}